<div class="w-full h-auto flex flex-col justify-end">
  @if (session.currentChat) {
    <div #chatViewContainer class="flex-1 w-full bg-[#FFFFFF]  flex flex-col">
      @for (message of session.messages; track message; let i = $index) {
        <div class="pb-6">
          @if (isNewDate(i)) {
            <div class="w-full pb-8 text-gray-400 flex text-xs justify-center items-center">
              <div class="flex-grow border-t-2 border-gray-100"></div>
              <p class="px-4 text-xs">{{ message.createdOn | date: 'dd.MM.yyyy' }}</p>
              <div class="flex-grow border-t-2 border-gray-100"></div>
            </div>
          }
          <!--        <div *ngIf="message.sender=='user'  && i === session.messages.length - 1" class="w-full flex justify-center py-2 text-gray-500 text-sm">-->
          <!--          <p>Thinking...</p>-->
        <!--        </div>-->
          @if (message.sender == 'user' && message.metadata?.['isBootstrapPlaceholder'] !== 'true') {
            <div class="flex w-full gap-4 items-start justify-end"
                 data-chatbic-message-role="user"
                 data-chatbic-user-message="true">
              <div [ngClass]="isCompactLayout() ? 'max-w-[85%]' : 'max-w-[50%]'"
                   class="rounded-lg p-2 bg-[#E6EAEC73] flex items-center">
                <p class="px-2 text-sm"
                   style="word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; white-space: pre-wrap;">{{ message.message }}</p>
              </div>
              @if (!isCompactLayout()) {
                <app-avatar [user]="chatService.getUser()"></app-avatar>
              }
            </div>
          }
          @if (message.sender != 'user' && !isContextEvent(message)) {
            <div data-chatbic-message-role="bot">
              <div [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'" class="w-full flex gap-4 items-start">
                  <div
                    class="flex items-center justify-center w-8 h-8 bg-gray-50 rounded-full border border-gray-100">
                    <fa-icon [icon]="faChatbicAi" style="color:#009999 !important;"></fa-icon>
                  </div>
                  <div (mouseenter)="hovering[i] = true"
                       (mouseleave)="hovering[i] = false" class="rounded-lg w-full flex flex-col items-start gap-2">
                    <!--
                      Die Zwischenschritte des Agenten gehoeren in DIESE Blase - dieselbe, in der
                      anschliessend die Antwort steht. Als eigener Block darunter waeren es zwei
                      Sprechblasen fuer eine Antwort.
                      Sie stehen oberhalb des Textes: erst erscheinen die Schritte, dann waechst
                      darunter die Antwort.
                    -->
                    @if (isThinkingMessage(message)) {
                      <div class="w-full flex flex-col gap-1.5 pb-1">
                        @if (session.toolSteps.length > 0) {
                          @for (step of groupedToolSteps; track step.key) {
                            <div class="flex items-start gap-2.5 text-sm">
                              <!-- Statuszeichen in fester Breite, damit die Beschriftungen
                                   untereinander auf einer Kante stehen. -->
                              <span class="w-4 shrink-0 flex items-center justify-center pt-0.5">
                                @switch (step.status) {
                                  @case ('done') {
                                    <fa-icon [icon]="faCheck" class="text-green text-xs"></fa-icon>
                                  }
                                  @case ('failed') {
                                    <fa-icon [icon]="faTriangleExclamation"
                                             class="text-yellow-600 text-xs"></fa-icon>
                                  }
                                  @default {
                                    <span class="w-1.5 h-1.5 rounded-full bg-green animate-pulse"></span>
                                  }
                                }
                              </span>
                              <span [ngClass]="step.status === 'done' ? 'text-gray-400' : 'text-gray-600'"
                                    class="leading-5">{{ step.label }}</span>
                              <!-- Mehrfachaufrufe desselben Werkzeugs: ein Zaehler statt derselben
                                   Zeile achtmal untereinander. -->
                              @if (step.count > 1) {
                                <span class="text-gray-400 leading-5 tabular-nums">×{{ step.count }}</span>
                              }
                              @if (step.detail && step.status !== 'done') {
                                <span class="text-gray-400 leading-5">· {{ step.detail }}</span>
                              }
                            </div>
                          }
                        } @else if (!message.message) {
                          <div class="flex items-center gap-2.5 text-sm">
                            <span class="w-4 shrink-0 flex items-center justify-center">
                              <span class="w-1.5 h-1.5 rounded-full bg-green animate-pulse"></span>
                            </span>
                            <span class="text-gray-600 leading-5">Denkt nach</span>
                          </div>
                        }
                      </div>
                    }
                    @if (hasUnavailableUiBlocks(message)) {
                      <div class="w-full flex flex-col gap-2 pb-3">
                        @for (uiBlock of getUnavailableUiBlocks(message); track trackByUiBlock($index, uiBlock); let blockIndex = $index) {
                          <app-ui-block-panel
                            [surface]="surface"
                            [blockIndex]="blockIndex"
                            [compact]="true"
                            [messageId]="message.id"
                            [uiBlock]="uiBlock"></app-ui-block-panel>
                        }
                      </div>
                    }
                    @if (isMycheckWelcomeMessage(message)) {
                      <div class="w-full flex flex-col gap-4">
                        @for (paragraph of getMycheckWelcomeParagraphs(message); track paragraph) {
                          <markdown #welcomeMd [data]="paragraph"
                                    (ready)="onMarkdownReady(welcomeMd, message)"
                                    (click)="onMarkdownClick($event)"
                                    class="chat-markdown w-full max-w-full text-sm"></markdown>
                        }
                        @if (shouldShowWelcomeUploadButton(message)) {
                          <div class="pt-1">
                          <bic-button (onClick)="chatService.openContextSelector(surface)"
                                      buttonType="white">
                            {{ getWelcomeUploadLabel(message) }}
                          </bic-button>
                          </div>
                        }
                      </div>
                    } @else {
                      <markdown #answerMd [data]="getMarkdown(message.message)"
                                (ready)="onMarkdownReady(answerMd, message)"
                                (click)="onMarkdownClick($event)"
                                [ngClass]="{'chat-streaming-text': isStreamingText(message)}"
                                class="chat-markdown w-full max-w-full text-sm"></markdown>
                    }
                  </div>
                </div>
              @if (hasInlineUiBlocks(message)) {
                <div [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'" class="w-full flex gap-4">
                    <div class="w-8 shrink-0"></div>
                    <div class="w-full p-2 flex flex-col gap-2">
                      @for (uiBlock of getInlineUiBlocks(message); track trackByUiBlock($index, uiBlock); let blockIndex = $index) {
                        <app-ui-block-panel
                          [surface]="surface"
                          [blockIndex]="blockIndex"
                          [compact]="true"
                          [messageId]="message.id"
                          [uiBlock]="uiBlock"></app-ui-block-panel>
                      }
                    </div>
                  </div>
                }
              @if (message.files) {
                <div [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'"
                     class="flex w-full pl-12">
                  <div class="w-full">
                    <div class="pt-4">
                        <p class="text-sm text-gray">Referenzen:</p>
                    </div>
                    <div [ngClass]="isCompactLayout() ? 'grid grid-cols-1 gap-2' : 'grid grid-cols-3 gap-6'"
                         class="pt-2 select-none w-full gap-2">
                      @for (file of getSourceFilesNew(message); track file; let j = $index) {
                        <div>
                          <div
                            class="rounded-lg py-2 px-2 w-full flex flex-row border gap-3 items-center border-gray-200 text-gray-500 cursor-default">
                            <p
                              [title]="file.name || file.fileName || 'Unknown File'"
                              class="text-sm font-medium text-ellipsis text-nowrap whitespace-nowrap break-normal overflow-hidden text-gray-500 flex-1 min-w-0">
                              {{ file.name || file.fileName || 'Unknown File' }}
                            </p>
                            <fa-icon
                              (click)="openSourceFile(file, $event)"
                              [icon]="faFile"
                              class="cursor-pointer text-base ml-auto text-gray-200">
                            </fa-icon>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (getAnswerSources(i).length > 0) {
                <div [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'"
                     [class.pt-1]="isMycheckWelcomeMessage(message)"
                     [class.pt-2]="!isMycheckWelcomeMessage(message)"
                     class="w-full flex justify-start pl-12">
                  <div class="flex flex-row flex-wrap gap-1.5">
                    @for (source of getAnswerSources(i); track source.label) {
                      <bic-badge type="info">
                        <div class="flex flex-row items-center gap-1.5">
                          <fa-icon [icon]="source.icon" class="text-xs"></fa-icon>
                          <span>{{ source.label }}</span>
                        </div>
                      </bic-badge>
                    }
                  </div>
                </div>
              }
              <!--
                Kopieren erst, wenn die Antwort vollstaendig ist. Waehrend des Streams waere der
                Knopf schon da, wuerde aber einen Bruchteil des Textes in die Ablage legen - und
                der Nutzer haette keinen Hinweis darauf.
              -->
              @if (!isThinkingMessage(message)) {
              <div [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'"
                   class="w-full flex justify-start pl-12 pt-2">
                <div class="flex items-center gap-2">
                  <!-- Copy button -->
                  <button (mouseover)="showTooltip('tooltip-copy-'+i,'tooltip-copy-button-'+i)"
                          [cdkCopyToClipboard]="copyText(message)"
                          (cdkCopyToClipboardCopied)="onMessageCopied($event, i)"
                          class="flex items-center justify-center p-1" data-tooltip-target="tooltip-copy-{{i}}"
                          id="tooltip-copy-button-{{i}}"
                          type="button">
                    <fa-icon [icon]="isMessageCopied(i) ? faCheck : faCopy"
                             [ngClass]="isMessageCopied(i) ? 'text-[#009999]' : 'text-gray-300 hover:text-gray-500'"></fa-icon>
                  </button>
                  @if (message.sender === 'bot' && !isWelcomeOrBootstrap(message)) {
                    <!-- Feedback: zweiter Klick auf denselben Daumen nimmt die Bewertung zurück. -->
                    <button (click)="chatService.setFeedback(surface, message, 1)" title="Hilfreich"
                            class="flex items-center justify-center p-1" type="button">
                      <fa-icon [icon]="faThumbsUp"
                               [ngClass]="message.metadata?.['feedbackRating'] === '1' ? 'text-[#009999]' : 'text-gray-300 hover:text-gray-500'"></fa-icon>
                    </button>
                    <button (click)="chatService.setFeedback(surface, message, -1)" title="Nicht hilfreich"
                            class="flex items-center justify-center p-1" type="button">
                      <fa-icon [icon]="faThumbsDown"
                               [ngClass]="message.metadata?.['feedbackRating'] === '-1' ? 'text-red-500' : 'text-gray-300 hover:text-gray-500'"></fa-icon>
                    </button>
                    @if (isLastBotMessage(i)) {
                      <button (click)="chatService.regenerate(surface, message)" title="Neu generieren"
                              [disabled]="session.isBotThinking"
                              class="flex items-center justify-center p-1" type="button">
                        <fa-icon [icon]="faRedo" class="text-gray-300 hover:text-gray-500"></fa-icon>
                      </button>
                    }
                  }
                </div>
                <div
                  class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-gray bg-gray-50 border border-gray-100 rounded-lg shadow-full opacity-0 tooltip"
                  id="tooltip-copy-{{i}}"
                     role="tooltip">
                  {{ isMessageCopied(i) ? 'Kopiert' : 'Kopieren' }}
                  <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
              </div>
              }
              <!-- Review-Leiste eines chatBIC-Vorschlags (#2789): unter der letzten Antwort, nicht
                   waehrend sie noch entsteht. -->
              @if (surface === 'edit' && isLastBotMessage(i) && !isThinkingMessage(message) && proposalReview.openCount() > 0) {
                <app-proposal-review-bar [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'"
                                         class="block pl-12 pt-3"></app-proposal-review-bar>
              }
            </div>
          }
      </div>
      }

      <!-- Ohne Antwort im Verlauf steht die Review-Leiste am Ende der Nachrichtenliste. -->
      @if (surface === 'edit' && !hasBotMessage() && proposalReview.openCount() > 0) {
        <app-proposal-review-bar [ngClass]="isCompactLayout() ? 'pr-2' : 'pr-24'"
                                 class="block pl-12 pb-6"></app-proposal-review-bar>
      }

      <div #questionAnchorSpacer aria-hidden="true"></div>
    </div>
  }
  @if (!session.currentChat && isCompactLayout()) {
    <div class="flex flex-col items-start justify-start h-full w-full gap-4">
      <p class="text-xs text-gray-500">
        chatBIC ist Ihr persönlicher KI‑Assistent und unterstützt Sie bei allen Fragen rund um die Nutzung der
        planBIC‑Plattform.
      </p>
      <div class="flex flex-col gap-2 w-full">
        @for (prompt of getFloatingPrompts(); track prompt) {
          <button (click)="usePrompt(prompt)"
                  class="flex items-center justify-between gap-4 w-full px-4 py-2 rounded-lg bg-gray-100
                         text-gray-500 text-xs text-left hover:bg-gray-200 transition-colors">
            <span>{{ prompt }}</span>
            <fa-icon [icon]="faChevronRight" class="text-xs shrink-0"></fa-icon>
          </button>
        }
      </div>
    </div>
  }
  @if (!session.currentChat && !isCompactLayout()) {
    <div class="flex flex-col justify-center items-center h-[inherit] w-full px-2 gap-12">
      <p class="font-semibold text-[24px]">
        Hallo, {{ getUserTitle() }}  {{ chatService.getUser()?.lastName }}
      </p>
      <!-- Reuse the input field from message-view -->
      <div class="flex flex-col items-center w-full">
        <!-- Input field -->
        <app-message-view [surface]="surface" class="w-[800px] max-w-full">
        </app-message-view>
        <!-- Prompts -->
        <div class="w-[800px] max-w-full flex flex-wrap gap-2 justify-center p-2 pt-14">
          @for (prompt of getPrompts(); track prompt) {
            <bic-badge (click)="usePrompt(prompt)" type="info">
              {{ prompt }}
            </bic-badge>
          }
        </div>
      </div>
    </div>
  }
</div>
